(function () {
  var DEFAULT_API_URL = 'https://checkout.valorandco.shop/api/track-order';

  function normalizeOrderNumber(value) {
    return String(value || '')
      .trim()
      .replace(/^#/, '')
      .replace(/\s+/g, '');
  }

  function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderTimeline(steps, currentStep) {
    return steps
      .map(function (step, index) {
        var state = 'is-pending';
        if (index < currentStep) state = 'is-complete';
        if (index === currentStep) state = 'is-current';

        return (
          '<li class="valor-track-order__step ' +
          state +
          '">' +
          '<span class="valor-track-order__step-dot" aria-hidden="true">' +
          (index < currentStep ? '✓' : index + 1) +
          '</span>' +
          '<div class="valor-track-order__step-body">' +
          '<h3>' +
          escapeHtml(step.title) +
          '</h3>' +
          '<p>' +
          escapeHtml(step.detail) +
          '</p>' +
          '<p><small>' +
          escapeHtml(step.date) +
          '</small></p>' +
          '</div>' +
          '</li>'
        );
      })
      .join('');
  }

  function renderItems(items) {
    return items
      .map(function (item) {
        var image = item.image
          ? '<img class="valor-track-order__item-image" src="' +
            escapeHtml(item.image) +
            '" alt="" width="56" height="56" loading="lazy">'
          : '<span class="valor-track-order__item-image valor-track-order__item-image--placeholder" aria-hidden="true"></span>';

        return (
          '<div class="valor-track-order__item">' +
          image +
          '<div class="valor-track-order__item-info">' +
          '<p class="valor-track-order__item-name">' +
          escapeHtml(item.title) +
          '</p>' +
          (item.variant
            ? '<p class="valor-track-order__item-variant">' + escapeHtml(item.variant) + '</p>'
            : '') +
          '</div>' +
          '<span class="valor-track-order__item-qty">×' +
          escapeHtml(item.quantity) +
          '</span>' +
          '</div>'
        );
      })
      .join('');
  }

  function renderResult(root, order) {
    var result = root.querySelector('[data-valor-track-result]');
    if (!result) return;
    var badgeClass = 'valor-track-order__status-badge';
    if (order.status === 'shipped') badgeClass += ' valor-track-order__status-badge--shipped';
    if (order.status === 'delivered') badgeClass += ' valor-track-order__status-badge--delivered';

    var trackingBlock = '';
    if (order.trackingNumber && order.trackingUrl) {
      trackingBlock =
        '<a class="valor-track-order__tracking-link" href="' +
        escapeHtml(order.trackingUrl) +
        '" target="_blank" rel="noopener noreferrer">Track parcel · ' +
        escapeHtml(order.trackingNumber) +
        '</a>';
    } else if (order.trackingNumber) {
      trackingBlock =
        '<p class="valor-track-order__tracking-link">Tracking · ' +
        escapeHtml(order.trackingNumber) +
        '</p>';
    }

    result.innerHTML =
      '<div class="valor-track-order__card valor-track-order__result is-visible">' +
      '<div class="valor-track-order__result-header">' +
      '<div class="valor-track-order__order-meta">' +
      '<h2>Order ' +
      escapeHtml(order.orderName) +
      '</h2>' +
      '<p>Placed ' +
      escapeHtml(order.placedAt) +
      (order.carrier ? ' · ' + escapeHtml(order.carrier) : '') +
      '</p>' +
      trackingBlock +
      '</div>' +
      '<span class="' +
      badgeClass +
      '">' +
      escapeHtml(order.statusLabel) +
      '</span>' +
      '</div>' +
      '<ol class="valor-track-order__timeline" aria-label="Order progress">' +
      renderTimeline(order.steps, order.currentStep) +
      '</ol>' +
      '<p class="valor-track-order__items-title">Items in this order</p>' +
      '<div class="valor-track-order__items">' +
      renderItems(order.items) +
      '</div>' +
      '</div>';

    result.classList.add('is-visible');
    result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function showError(root, message) {
    var error = root.querySelector('[data-valor-track-error]');
    if (!error) return;
    error.textContent = message;
    error.classList.add('is-visible');
  }

  function hideError(root) {
    var error = root.querySelector('[data-valor-track-error]');
    if (!error) return;
    error.textContent = '';
    error.classList.remove('is-visible');
  }

  function hideResult(root) {
    var result = root.querySelector('[data-valor-track-result]');
    if (!result) return;
    result.classList.remove('is-visible');
    result.innerHTML = '';
  }

  function initSection(root) {
    var form = root.querySelector('[data-valor-track-form]');
    if (!form || form.dataset.valorBound === 'true') return;
    form.dataset.valorBound = 'true';

    var apiUrl = root.dataset.apiUrl || DEFAULT_API_URL;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideError(root);
      hideResult(root);

      var orderInput = form.querySelector('[name="order_number"]');
      var emailInput = form.querySelector('[name="email"]');
      var submit = form.querySelector('[type="submit"]');
      var orderNumber = normalizeOrderNumber(orderInput.value);
      var email = normalizeEmail(emailInput.value);

      if (!orderNumber || !email) {
        showError(root, 'Please enter your order number and email address.');
        return;
      }

      submit.disabled = true;

      fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          order_number: orderNumber,
          email: email,
        }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          submit.disabled = false;
          if (!result.ok || !result.data || !result.data.order) {
            showError(
              root,
              (result.data && result.data.error) || 'Order not found. Please check your details.'
            );
            return;
          }
          renderResult(root, result.data.order);
        })
        .catch(function () {
          submit.disabled = false;
          showError(root, 'Something went wrong. Please try again in a moment.');
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-valor-track-order]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
